import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0cde4b89"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "cyber xl:tw-flex tw-bg-[#0345BD] tw-rounded-md tw-p-[20px] tw-items-center",
  style: {"border":"1px solid var(--Brand-Azure, #0345bd)"}
}
const _hoisted_2 = {
  key: 0,
  class: "tw-flex tw-px-[32px] tw-py-[7px] tw-bg-[#d9edff] tw-rounded-md tw-mr-[25px] tw-max-w-[160px] cyber__logo"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "tw-text-[#fff] tw-flex tw-flex-col tw-justify-center tw-gap-[8px]" }
const _hoisted_5 = { class: "tw-text-[16px] tw-font-semibold tw-leading-[21px]" }
const _hoisted_6 = {
  key: 0,
  class: "tw-text-[13px] tw-font-normal tw-leading-[17px]"
}

import { onMounted, ref, Ref, watch } from "vue";
import customDescriptionContent from "@/components/common/customDescriptionContent.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'actionsOverviewDescription',
  props: {
  data: {
    type: Object as () => any,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const img: Ref<any> = ref("");
const description: Ref<any> = ref("");

onMounted(() => {
  parseDescription();
});

const parseDescription = () => {
  const checklistGroupDescription =
    props.data?.item?.checklistGroupDescription || "";
  try {
    const descriptions = JSON.parse(checklistGroupDescription);
    if (descriptions?.image) {
      const startChar = descriptions?.image.slice(0, 2);
      img.value = `data:image/${
        startChar !== "iV" ? "svg+xml" : "png"
      };base64,${descriptions?.image}`;
    }
    description.value = descriptions?.description;
  } catch (e) {
    description.value = checklistGroupDescription;
  }
};

watch(
  () => props.data,
  () => {
    parseDescription();
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (img.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("img", {
            src: img.value,
            alt: "logo",
            class: "tw-w-full tw-h-full"
          }, null, 8, _hoisted_3)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, _toDisplayString(__props.data?.item?.title), 1),
      (description.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(customDescriptionContent, {
              description: description.value,
              "custom-class": '!tw-p-[0px] tw-text-[#fff]',
              "is-recommendation": true
            }, null, 8, ["description"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})